import clsx from 'clsx';
import { forwardRef } from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<HTMLInputElement, InputProps>(({ className, readOnly, ...props }, ref) => {
  return (
    <div className={clsx(className, 'flex flex-col gap-[6px]')}>
      <input
        className={clsx(
          'flex h-[48px] w-full rounded-[8px] border border-primary-50 items-center px-[16px] text-[14px] placeholder:text-gray-500 disabled:text-[#949EAC] focus-visible:outline-none disabled:cursor-default',
          readOnly
            ? 'bg-primary-50 text-grey cursor-not-allowed'
            : 'focus:border-primary-300 bg-white  text-primary-900'
        )}
        ref={ref}
        readOnly={readOnly}
        {...props}
      />
    </div>
  );
});
Input.displayName = 'Input';

export { Input };
